export default __webpack_public_path__ + "static/media/WhatsApp Community_Wahda.3b875fba.jpeg";